
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import classNames from '../../../node_modules/classnames/index.js';
import { tabNavItem } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var TabsNavItem = function TabsNavItem(_ref) {
  var index = _ref.index,
    title = _ref.title,
    isActive = _ref.isActive,
    id = _ref.id,
    onSelectTab = _ref.onSelectTab,
    _onKeyDown = _ref.onKeyDown;
  var HtmlClasses = classNames({
    "tab-link": true,
    selected: isActive
  });
  var onClick = function onClick() {
    onSelectTab(index);
  };
  return jsx("div", {
    css: function css(theme) {
      return tabNavItem(theme, {
        isActive: isActive
      });
    },
    id: id !== null && id !== void 0 ? id : "tab-".concat(index),
    "data-testid": id ? "".concat(id, "-tab") : "tab-".concat(index),
    "aria-controls": "content-".concat(index),
    "aria-selected": isActive,
    tabIndex: isActive ? 0 : -1,
    role: "tab",
    className: HtmlClasses,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e, index);
    },
    ref: function ref(el) {
      if (isActive && index !== 0 && el) {
        el.focus({
          preventScroll: true
        });
      }
    }
  }, title);
};

export { TabsNavItem as default };
//# sourceMappingURL=TabsNavItem.js.map
